import { api } from "../app/endpoints";
import { language } from "./helpers/service-helper";

export const fetchWystawy = () =>
  fetch(api.wystawy)
    .then((res) => res.json())
    .then((data) => data.items)
    .then(language);
